module.exports = __webpack_public_path__ + "img/bg_tjhby.e54c561e.svg";